"use strict";
var $ = require("../internals/export");
var iterate = require("../internals/iterate");
var aCallable = require("../internals/a-callable");
var anObject = require("../internals/an-object");
var getIteratorDirect = require("../internals/get-iterator-direct");
var iteratorClose = require("../internals/iterator-close");
var iteratorHelperWithoutClosingOnEarlyError = require("../internals/iterator-helper-without-closing-on-early-error");
var apply = require("../internals/function-apply");
var fails = require("../internals/fails");
var $TypeError = TypeError;
var FAILS_ON_INITIAL_UNDEFINED = fails(function() {
  [].keys().reduce(function() {
  }, void 0);
});
var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError("reduce", $TypeError);
$({ target: "Iterator", proto: true, real: true, forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError }, {
  reduce: function reduce(reducer) {
    anObject(this);
    try {
      aCallable(reducer);
    } catch (error) {
      iteratorClose(this, "throw", error);
    }
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? void 0 : arguments[1];
    if (reduceWithoutClosingOnEarlyError) {
      return apply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
    }
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function(value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError("Reduce of empty iterator with no initial value");
    return accumulator;
  }
});
